import React from 'react'
import TsxUtils from 'utils/tsx'
import './FormColumn.scss'

export interface FormColumnProps {
  className?: string
  children: React.ReactNode
}

const FormColumn: React.FC<FormColumnProps> = ({ children, className }) => (
  <div className={`FormColumn` + TsxUtils.extraStyle(className, className)}>{children}</div>
)

export default FormColumn
